<script lang="jsx">
import Base from "../config.vue";
import EditSimple from "./edit-simple.vue";
import EditDelta from "./edit-delta.vue";
import planPropsMixin from '@/plans/mx/plan-props';

export default {
  mixins: [planPropsMixin],
  render() {
    if (this.$context.is.edit) {
      if (this.$context.is.addQty) {
        return <EditDelta {...this.$attrs} />;
      } else if (this.$context.is.simplify) {
        return <EditSimple />;
      } else {
        return <Base />;
      }
    } else {
      return <Base />;
    }
  },
};
</script>
